import axios from 'axios'

export default {
  namespaced: true,

  state: {
    betHistory: [],
    count: 0
  },

  getters: {},

  mutations: {
    SET_BETSLIP (state, data) {
      state.betHistory = data
    },

    SET_BETSLIP_COUNT (state, data) {
      state.count = data[0].total
    },

    CANCEL_BETSLIP (state, data) {
      state.betHistory.forEach((betslip) => {
        if (betslip.id === data.id) {
          betslip.isCancel = data.isCancel
        }
      })
    },

    DELETE_BETSLIP (state, data) {
      state.betHistory.forEach((betslip) => {
        if (betslip.id === data.id) {
          betslip.isHide = 1
        }
      })
    },

    RESTORE_BETSLIP (state, data) {
      state.betHistory.forEach((betslip) => {
        if (betslip.id === data.id) {
          betslip.isHide = data.isHide
        }
      })
    }
  },

  actions: {
    async get ({ commit }, params) {
      let result = await axios
        .get('/bet-history', { params })

      let count = await axios
        .get('/bet-history/count', { params })

      commit('SET_BETSLIP', result.data)
      commit('SET_BETSLIP_COUNT', count.data)
    },

    async getByAgent ({ commit }, { id, params }) {
      let result = await axios.get(`/bet-history/agent/${id}`, { params })
      commit('SET_BETSLIP', result.data.data)
      commit('SET_BETSLIP_COUNT', result.data.count)
    },

    async cancel ({ commit }, params) {
      await axios
        .patch(`/bet-history/${params.id}/cancel`, params)

      commit('CANCEL_BETSLIP', params)
    },

    async delete ({ commit }, params) {
      await axios
        .delete(`/bet-history/${params.id}`)

      commit('DELETE_BETSLIP', params)
    },

    async restore ({ commit }, params) {
      await axios
        .patch(`/bet-history/${params.id}/restore`, params)

      commit('RESTORE_BETSLIP', params)
    },

    async getAttachBetslip ({ commit }, params) {
      let result = await axios
        .get('/bet-history/helpdesk', { params })

      commit('SET_BETSLIP', result.data)
    }
  }
}
